import { createClient } from '@supabase/supabase-js';

const url = process.env.SP_SUPABASE_URL;
const anonKey = process.env.SP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Surface a clear message instead of a blank screen when .env is missing.
  document.getElementById('root').innerHTML =
    '<p style="padding:40px;font-family:monospace">SP_SUPABASE_URL / SP_SUPABASE_ANON_KEY not set — check .env</p>';
  throw new Error('Missing Supabase env');
}

export const supabase = createClient(url, anonKey);
